export default "__VITE_ASSET__DxYTzILb__"